module.exports = __webpack_public_path__ + "img/cart-x.e088bb18.svg";